var app = angular.module('leonardo');

var LaunchWorkFlowDialog = function (
  $scope,
  $q,
  $rootScope,
  $state,
  WorkFlowService,
  ngDialog,
  FilterService,
  PropertyService,
  NotificationService,
  FormErrorsService,
  $filter,
  AnalyticsService,
) {
  $scope.workflow = $scope.ngDialogData.workflow;
  $scope.workflow_id = $scope.ngDialogData.workflow_id;
  $scope.items = $scope.ngDialogData.items;
  $scope.unit = $scope.ngDialogData.unit;
  $scope.is_launch_trigger_wfs = $scope.ngDialogData.is_launch_trigger_wfs;
  $scope.is_mrb = $scope.ngDialogData.is_mrb;
  $scope.context = $scope.ngDialogData.context;

  $scope.parent_property = $scope.ngDialogData.property;

  $scope.date_turn = moment().format('YYYY-MM-DD');
  $scope.property = null;
  $state.time_zone = null;
  $scope.portfolio = FilterService.currentPortfolio;

  $scope.name = $scope.workflow.name;
  $scope.workFlowService = WorkFlowService;
  $scope.data = {
    trigger_workflow: null,
    property: $scope.parent_property ? angular.copy($scope.parent_property) : null
  };

  $scope.init = function () {
    var params = {
      'disable_pagination': true
    }
    $scope.trigger_workflows = [];
    if ($scope.is_launch_trigger_wfs) {
      $scope.data.trigger_workflow = $scope.workflow_id;
      WorkFlowService.triggerWorkflowList($scope.workflow_id, params).then(function (data) {
        var list = data.results || data;
        $scope.trigger_workflows = $filter('orderBy')(list, 'name');
      });
    }
  };

  $scope.showAddUnitDialog = function () {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/workflow/unit-list.html',
        controller: 'WorkFlowUnitSelectDialog',
        className: 'ngdialog-theme-default ngdialog-unit-add',
        data: {
          property: $scope.data.property,
          workflowId: $scope.workflow.id
        }
      })
      .then(function (results) {
        var params = {
          name: $scope.name,
          active_templates: $scope.items,
          property: $scope.data.property,
          date_of_turn: $scope.date_turn,
          filter_conditions: results
        };
        $scope.workflow.activate(params).then(
          function () {
            AnalyticsService.track('Workflow Launched', {
              ...AnalyticsService.getWorkflowGroupProperties($scope.workflow, $scope.data.property, $scope.portfolio),
              context: $scope.context
            });
            FilterService.setProperty($scope.data.property).then(function () {
              $rootScope.$broadcast('workflow-tasks:updated');
              $scope.confirm();
            });
          },
          function () {
            $scope.confirm();
          }
        );
      });
  };

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if ($scope.workflow.by_unit) {
      $scope.showAddUnitDialog();
    } else if ($scope.workflow.unit) {
      var unit_value = [{ units: [$scope.workflow.unit.id] }];
      if ($scope.data.trigger_workflow == $scope.workflow_id) {
        var params = {
          name: $scope.name,
          active_templates: $scope.items,
          property: $scope.data.property,
          date_of_turn: $scope.date_turn,
          filter_conditions: unit_value
        };
        WorkFlowService.activate($scope.data.trigger_workflow, params).then(
          function () {
            AnalyticsService.track('Workflow Launched', {
              ...AnalyticsService.getWorkflowGroupProperties($scope.workflow, $scope.data.property, $scope.portfolio),
              context: $scope.context
            });
            FilterService.setProperty($scope.data.property).then(function () {
              $rootScope.$broadcast('workflow-tasks:updated');
              $scope.confirm();
            });
          },
          function () {
            $scope.confirm();
          }
        );
      } else {
        WorkFlowService.get($scope.data.trigger_workflow).then(function (data) {
          var items_ids = [];
          angular.forEach(data.templates, function (value) {
            items_ids.push(value.id);
          });
          var param = {
            name: $scope.name,
            active_templates: items_ids,
            property: $scope.data.property,
            date_of_turn: $scope.date_turn,
            filter_conditions: unit_value
          };
          WorkFlowService.activate($scope.data.trigger_workflow, param).then(
            function () {
              AnalyticsService.track('Workflow Launched', {
                ...AnalyticsService.getWorkflowGroupProperties($scope.workflow, $scope.data.property, $scope.portfolio),
                context: $scope.context
              });
              FilterService.setProperty($scope.data.property).then(function () {
                $rootScope.$broadcast('workflow-tasks:updated');
                $scope.confirm();
              });
            },
            function () {
              $scope.confirm();
            }
          );
        });
      }
    } else {
      if ($scope.is_launch_trigger_wfs) {
        if ($scope.data.trigger_workflow == $scope.workflow_id) {
          WorkFlowService.activate($scope.data.trigger_workflow, {
            name: $scope.name,
            active_templates: $scope.items,
            property: $scope.data.property,
            date_of_turn: $scope.date_turn
          }).then(function () {
            AnalyticsService.track('Workflow Launched', {
              ...AnalyticsService.getWorkflowGroupProperties($scope.workflow, $scope.data.property, $scope.portfolio),
              context: $scope.context
            });
            FilterService.setProperty($scope.data.property).then(function () {
              $rootScope.$broadcast('workflow-tasks:updated');
              $scope.confirm();
            });
          }, function () {
            $scope.confirm();
          });
        } else {
          WorkFlowService.get($scope.data.trigger_workflow).then(function (data) {
            var items_ids = [];
            angular.forEach(data.templates, function (value) {
              items_ids.push(value.id);
            });
            var objparam = {
              name: $scope.name,
              active_templates: items_ids,
              property: $scope.data.property,
              date_of_turn: $scope.date_turn,
            };
            WorkFlowService.activate($scope.data.trigger_workflow, objparam).then(function () {
              AnalyticsService.track('Workflow Launched', {
                ...AnalyticsService.getWorkflowGroupProperties($scope.workflow, $scope.data.property, $scope.portfolio),
                context: $scope.context
              });
              FilterService.setProperty($scope.data.property).then(function () {
                $rootScope.$broadcast('workflow-tasks:updated');
                $scope.confirm();
              });
            }, function () {
              $scope.confirm();
            });
          });
        }
      } else {
        $scope.workflow
          .activate({
            name: $scope.name,
            active_templates: $scope.items,
            property: $scope.data.property,
            date_of_turn: $scope.date_turn
          })
          .then(
            function () {
              AnalyticsService.track('Workflow Launched', {
                ...AnalyticsService.getWorkflowGroupProperties($scope.workflow, $scope.data.property, $scope.portfolio),
                context: $scope.context
              });
              FilterService.setProperty($scope.data.property).then(function () {
                $rootScope.$broadcast('workflow-tasks:updated');
                $scope.confirm();
              });
            },
            function () {
              $scope.confirm();
            }
          );
      }
    }
  };

  $scope.$watch('data.property', function (newValue, oldValue) {
    if (!angular.equals(newValue, oldValue) && newValue) {
      PropertyService.one(newValue)
        .get({ essential: true })
        .then(function (property) {
          $scope.time_zone = property.time_zone;
          $scope.portfolio = property.portfolio;
        });
    }
  });

  $scope.init();
};

app.controller('LaunchWorkFlowDialog', [
  '$scope',
  '$q',
  '$rootScope',
  '$state',
  'WorkFlowService',
  'ngDialog',
  'FilterService',
  'PropertyService',
  'NotificationService',
  'FormErrorsService',
  '$filter',
  'AnalyticsService',
  LaunchWorkFlowDialog
]);